import { Autocomplete, Checkbox, FormControl, Typography } from '@mui/material';
import { NotificationRole } from '@provision/entity-types';
import { HTMLAttributes, Key, SyntheticEvent } from 'react';
import { NotificationRoleResponse } from 'src/graphql/entities/notification-preference';
import { StyledTextField } from 'src/pages/Settings/notifications/styled';

export type NotificationRoleSelectProps = {
  roleOptions: NotificationRole[];
  selectedValues: NotificationRoleResponse[];
  onChange: (event: SyntheticEvent, nextValues: NotificationRoleResponse[]) => void;
};

export const NotificationRoleSelect = ({
  roleOptions,
  selectedValues,
  onChange,
}: NotificationRoleSelectProps) => {
  return (
    <FormControl fullWidth>
      {roleOptions.length > 0 ? (
        <Autocomplete<NotificationRoleResponse, true, true>
          multiple
          size="small"
          disableClearable
          value={selectedValues}
          onChange={onChange}
          options={roleOptions}
          disableCloseOnSelect
          getOptionLabel={(option) => option?.name}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          renderInput={(params) => (
            <StyledTextField
              {...params}
              label={selectedValues.length === 0 ? 'Never' : null}
              InputLabelProps={{ size: 'small' }}
            />
          )}
          renderOption={(
            props: HTMLAttributes<HTMLLIElement> & {
              key: Key | null | undefined;
            },
            option,
            { selected },
          ) => {
            const { key, ...optionProps } = props;
            return (
              <li key={key} {...optionProps}>
                <Checkbox size="small" style={{ padding: 4 }} checked={selected} />
                {option.name}
              </li>
            );
          }}
        />
      ) : (
        <Typography variant="body2">Always</Typography>
      )}
    </FormControl>
  );
};
